import { SalesStats } from 'src/app/models/core/chart-interfaces';

/** Las 4 métricas del bloque, en orden de pantalla. Las de físicos no entran acá. */
const BLOCK_STAT_KEYS = [
  'reports-single-event.tickets-sold',
  'reports-single-event.registered',
  'reports-single-event.verified',
  'reports-single-event.absent',
] as const;

/** Tickets físicos anónimos (carga masiva): solo existen si el evento los tiene; van debajo. */
const PHYSICAL_STAT_KEYS = [
  'reports-single-event.physical-tickets',
  'reports-single-event.physical-registered',
  'reports-single-event.physical-verified',
  'reports-single-event.physical-absent',
] as const;

/** Verificados y Ausentes muestran su % junto a la cifra ("11 · 11%"). */
const STATS_WITH_PERCENT: ReadonlySet<string> = new Set([
  'reports-single-event.verified',
  'reports-single-event.absent',
  'reports-single-event.physical-verified',
  'reports-single-event.physical-absent',
]);

/** Una métrica lista para `app-flat-stat`. */
export interface MetricStat {
  readonly titleKey: string;
  readonly display: string;
  readonly interactive: boolean;
}

/**
 * Métricas del bloque de un evento (Jefe en su Inicio, Vendedor en Mis ventas,
 * Recepcionista en Asistencia): las 4 principales primero y las de físicos, si
 * hay, debajo. Si una métrica navega lo decide solo su `clickable`, que pone el
 * mapper (`event-kpis.mapper`); acá solo se ordena y se arma el texto.
 */
export function buildMetricStats(all: readonly SalesStats[]): MetricStat[] {
  return [...BLOCK_STAT_KEYS, ...PHYSICAL_STAT_KEYS].flatMap((key) => {
    const stat = all.find((s) => s.titleKey === key);
    if (!stat) return [];
    const display = STATS_WITH_PERCENT.has(key)
      ? `${stat.value} · ${stat.percentage}%`
      : String(stat.value);
    return [{ titleKey: key, display, interactive: stat.clickable === true }];
  });
}
